import * as React from 'react';
import Button from '@mui/material/Button';
import { styled, SxProps } from '@mui/material/styles';

const CustomButton = styled(Button)(({ theme }) => ({
  borderRadius: '15px',
  color: '#ffffff',
  fillRule: 'evenodd',
  textTransform: 'none',
  fontWeight: 'bold',
  backgroundColor: 'rgba(255,255,255,0.09803921568627451 )',
  whiteSpace: 'nowrap',
  padding: '15px',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#36899f',
    boxShadow: 'none',
  },
  [theme.breakpoints.down('lg')]: {
    padding: '10px',
    fontSize: '14px',
  },
  [theme.breakpoints.down('md')]: {
    padding: '6px',
    fontSize: '12px',
  },
  boxShadow: 'none',
}));

const GlobalButton = styled(CustomButton)(({ theme }) => ({
  background: 'rgba(255,255,255,0.09803921568627451 )',
  '&:hover': {
    backgroundColor: 'rgba(255,255,255,0.09803921568627451 )',
  },
}));

const YellowButton = styled(CustomButton)(({ theme }) => ({
  background: '#ddb930',
  '&:hover': {
    backgroundColor: '#ddb930',
  },
}));

const SkyButton = styled(CustomButton)(({ theme }) => ({
  background: '#36899f',
  '&:hover': {
    backgroundColor: '#36899f',
  },
}));

const TranparentButton = styled(CustomButton)(({ theme }) => ({
  background: 'transparent',
  '&:hover': {
    backgroundColor: 'transparent',
  },
  ':disabled': {
    backgroundColor: 'transparent',
  },
}));

interface normalButtonProps {
  color?: string;
  text?: string | JSX.Element;
  isClicked?: boolean;
  style?: Object;
  onClick?: any;
  children?: React.ReactNode | React.ReactNode[];
  Icon?: React.ReactElement;
  isDisabled?: boolean;
  sx?: SxProps;
  ref?: any;
}

const NormalButton: React.FC<normalButtonProps> = ({
  color,
  text,
  isClicked,
  style,
  children,
  onClick,
  Icon,
  isDisabled,
  sx,
  ref,
}) => {
  return color === 'yellow' ? (
    <YellowButton
      disabled={isDisabled}
      variant="contained"
      sx={sx}
      style={style}
      onClick={onClick}
      ref={ref}
    >
      {Icon} {text}
      {children}
    </YellowButton>
  ) : color === 'sky' ? (
    <SkyButton
      disabled={isDisabled}
      variant="contained"
      sx={sx}
      style={style}
      onClick={onClick}
      ref={ref}
    >
      {Icon}
      {text}
      {children}
    </SkyButton>
  ) : color === 'transparent' ? (
    <TranparentButton
      variant="contained"
      sx={sx}
      disabled={isDisabled}
      style={style}
      onClick={onClick}
      ref={ref}
    >
      {Icon}
      {text}
      {children}
    </TranparentButton>
  ) : (
    <GlobalButton
      disabled={isDisabled}
      variant="contained"
      sx={sx}
      style={style}
      onClick={onClick}
      ref={ref}
    >
      {Icon}
      {text}
      {children}
    </GlobalButton>
  );
};

export default NormalButton;
